
export default {
  props: {
    url: String
  }
};
